import { render, staticRenderFns } from "./ChildPage.vue?vue&type=template&id=ec35ba44&"
import script from "./ChildPage.vue?vue&type=script&lang=ts&"
export * from "./ChildPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports